import { render, staticRenderFns } from "./nfc.vue?vue&type=template&id=628a3ee2&scoped=true"
import script from "./nfc.vue?vue&type=script&lang=js"
export * from "./nfc.vue?vue&type=script&lang=js"
import style0 from "./nfc.vue?vue&type=style&index=0&id=628a3ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a3ee2",
  null
  
)

export default component.exports